module.exports = __webpack_public_path__ + "img/masonry.041bab6d.png";